module.exports = __webpack_public_path__ + "static/media/s5-top-right.1270fcd7.png";